var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { useCallback } from 'react';
import { useBottomNavBar } from '@agentguru/layout';
import styles from './BottomNavBarWhatsNew.module.scss';
export function BottomNavBarWhatsNew() {
    var _a = useBottomNavBar(), setShowRoutesModal = _a.setShowRoutesModal, setCurrentRouteByKey = _a.setCurrentRouteByKey;
    var handleClick = useCallback(function () {
        setShowRoutesModal(true);
        setCurrentRouteByKey(1);
    }, [setCurrentRouteByKey, setShowRoutesModal]);
    return (_jsxs("button", __assign({ type: "button", className: classnames(styles.container, styles.isWhatsNewButton), onClick: handleClick }, { children: [_jsxs("div", { children: [_jsx("i", { className: "icon-ag-whats-new" }), _jsx("span", { children: "What's New" })] }), _jsx("i", { className: "icon-ag-arrow-right" })] })));
}
